<div class="version-nav">
  <!-- Toolbar Navigation - Commented out as header handles navigation -->
  <!--
  <mat-toolbar color="primary">
    <span>{{ dashboardTitle }}</span>
    <span class="spacer"></span>

    <button mat-button routerLink="/" routerLinkActive="active">
      <mat-icon>home</mat-icon>
      Home
    </button>

    <button mat-button [matMenuTriggerFor]="universityMenu" routerLinkActive="active">
      <mat-icon>school</mat-icon>
      Education
      <mat-icon>expand_more</mat-icon>
    </button>

    <mat-menu #universityMenu="matMenu">
      <button mat-menu-item (click)="navigateToEducation('education-university')">
        <mat-icon>analytics</mat-icon>
        University Analysis
      </button>
      <button mat-menu-item (click)="navigateToEducation('education-student')">
        <mat-icon>person</mat-icon>
        Discover AI Courses (Student)
      </button>
    </mat-menu>

    <button (click)="logout()" style="justify-content: end; display: none;" mat-raised-button color="warn"
      class="logout-btn">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </mat-toolbar>
  -->

  <!-- Dashboard Header -->
  <header class="dashboard-header" *ngIf="showDashboardHeader">
    <div class="header-content">
      <div class="logo-welcome-section">
        @if (!isGenericFlowActive()) {
        <img src="images/logo/logo.webp" alt="Brand Score AI Logo" class="dashboard-logo">
        }
        <div class="welcome-section">
          <h1>{{ getGreeting() }}, {{ currentUser?.first_name }}!</h1>
          <p class="user-info">
            <span class="user-type">{{ currentUser?.user_type }}</span>
            <!-- <span class="user-role">{{ currentUser?.role }}</span> -->
            @if(currentUser?.business_title !== 'NA') {
            <span class="business-title">{{ currentUser?.business_title }}</span>
            }
          </p>
        </div>
      </div>

      <!-- Navigation Menu -->
      <nav class="nav-menu">
        <!-- [routerLink]="isGenericFlowActive()?'/generic-dashboard':'/education-dashboard'" -->
        <button mat-button routerLink="/dashboard" routerLinkActive="active">
          <mat-icon>dashboard</mat-icon>
          Dashboard
        </button>

        @if (!isGenericFlowActive()) {
        <!-- Education Dropdown Menu -->
        <button mat-button [matMenuTriggerFor]="educationMenu" routerLinkActive="active">
          <mat-icon>school</mat-icon>
          Education
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #educationMenu="matMenu">
          <button mat-menu-item (click)="navigateToEducation('education-university')">
            <mat-icon>analytics</mat-icon>
            University Analysis
          </button>
          <button mat-menu-item (click)="navigateToEducation('education-student')">
            <mat-icon>person</mat-icon>
            Discover AI Courses (Student)
          </button>
        </mat-menu>
        }

        <!-- Admin Management Menu -->
        <button mat-button [matMenuTriggerFor]="adminMenu" routerLinkActive="active" *ngIf="isAdmin()">
          <mat-icon>admin_panel_settings</mat-icon>
          Management
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #adminMenu="matMenu">
          <button mat-menu-item routerLink="/admin/users" *ngIf="canAccessUserManagement()">
            <mat-icon>people</mat-icon>
            User Management
          </button>
          <button mat-menu-item routerLink="/admin/roles" *ngIf="canAccessRoleManagement()">
            <mat-icon>security</mat-icon>
            Role Management
          </button>
          <button mat-menu-item routerLink="/admin/projects" *ngIf="canAccessProjectManagement()">
            <mat-icon>business</mat-icon>
            Project Management
          </button>
          <button mat-menu-item routerLink="/admin/settings" *ngIf="isAdmin()">
            <mat-icon>settings</mat-icon>
            Settings
          </button>
          <button mat-menu-item routerLink="/admin/discovery-pages" *ngIf="isAdmin()">
            <mat-icon>web</mat-icon>
            Discovery Pages
          </button>
          <button mat-menu-item routerLink="/admin/discovery-citations" *ngIf="isAdmin()">
            <mat-icon>format_list_bulleted</mat-icon>
            Discovery Citations
          </button>
          <button mat-menu-item routerLink="/admin/tab-notes" *ngIf="isAdmin()">
            <mat-icon>note</mat-icon>
            Tab Notes
          </button>
        </mat-menu>

        <!-- Member/University Management Menu -->
        <button mat-button routerLink="/university/projects" routerLinkActive="active"
          *ngIf="(isUniversity() || isMember()) && !isAdmin()">
          <mat-icon>business</mat-icon>
          My Projects
        </button>
      </nav>

      <div class="header-actions">
        <app-notification-bell></app-notification-bell>
        <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item routerLink="/change-password">
            <mat-icon>lock</mat-icon>
            <span>Change Password</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </header>
</div>
